import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { AmsRewardsCsvComponent }   from './ams-rewards.csv.component';
import { ApiService }               from '../api/api.service';
import { CodeTypeModel }            from '../core/models/code-type';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { ConfirmService }           from '../messages/confirm/confirm.service';

@Injectable({
  providedIn: 'root'
})
export class AmsRewardsService {
  public title = this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.AMS_REWARDS.AMS_REWARDS');

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  activate () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
        name: this.title
      }))
      .then(() => this.apiService.get('/company_integration/add_ams_rewards'));
  }

  deactivate () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
        name: this.title
      }))
      .then(() => this.apiService.get('/company_integration/remove_ams_rewards'));
  }

  downloadCsv () : ng.IPromise<any> {
    const modal =  this.modalService.open(AmsRewardsCsvComponent);

    return modal.result;
  }

  getAutoClubs () : ng.IPromise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/ams_autoclubs');
  }

  getDownloadUrl ( startDate : string, endDate : string ) : string {
    return `${ this.apiService._API.url }/ams-rewards/download_csv/${ startDate }/${ endDate }`;
  }

  getFileFrequency () : ng.IPromise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/ams_file_frequency');
  }

  save ( settings : CompanyIntegrationsModel ) : ng.IPromise<string> {
    return this.apiService.patch('/company_integrations', settings, 'company_integration')
      .then(( data : CompanyIntegrationsModel ) => data.ams_first_setup
        ? this.sendActivationEmail(data)
          .then(() => this.translateService.instant('JS_SPACE.AMS_REWARDS.REQUEST_SENT', {
            name: this.title
          }))
        : this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'));
  }

  sendActivationEmail ( data : CompanyIntegrationsModel ) : ng.IPromise<any> {
    return this.apiService.post('/ams_rewards/send_activation_email_to_ams', data, 'ams_rewards');
  }

  sendCsv ( startDate : string, endDate : string ) : ng.IPromise<any> {
    return this.apiService.get('/ams_rewards/send_csv', [ startDate, endDate ]);
  }
}
